import gql from 'graphql-tag';
import { kmsClient } from '../../apollo';
import {
  PublisherPageLockedArticlesQuery,
  PublisherPageLockedArticlesQueryVariables
} from './__generated__/PublisherPageLockedArticlesQuery';

// Page-Locked Articles: the publisher setting alone, read again by the campaign form when its tab gets focus back.
export const PUBLISHER_PAGE_LOCKED_ARTICLES_QUERY = gql`
  query PublisherPageLockedArticlesQuery($id: ID!) {
    publisher(id: $id) {
      id
      pageLockedArticlesEnabled
    }
  }
`;

export const fetchPublisherPageLockedArticlesEnabled = async (id: string) => {
  const { data } = await kmsClient.query<PublisherPageLockedArticlesQuery, PublisherPageLockedArticlesQueryVariables>({
    query: PUBLISHER_PAGE_LOCKED_ARTICLES_QUERY,
    variables: { id },
    fetchPolicy: 'no-cache'
  });
  return data.publisher.pageLockedArticlesEnabled;
};
